<fou-group v-if="isCustomerMsg(fontResults)">
  <div :class="$style.custMsgTitle">
    <h3 :class="[$style.custMsg]">{{$t('pages.submissions.components.customerMessage.title')}}</h3>
    <p>{{$t('pages.submissions.components.customerMessage.title_optional')}}</p>
  </div>
  <p :class="[$style.custMsgDesc]">{{$t('pages.submissions.components.customerMessage.description')}}</p>

  <FouTextArea
    :id="$vId(this, 'customer-message')"
    name="customerMessage uploads"
    label="Customer Message"
    :input-class="['mt-textarea mt-group', {[$style.mtCustomerInputError]: Object.hasOwn(errors, 'customerMessage uploads')}]"
    v-model="customerMessage"
    maxlength="50000"
    rows="4"
    :moduleName="this.$route.name"
    :foundryId="this.submission.foundry?.foundryId"
    :description="customerMessage"
    @update-banned-word="bannedWordforCustomerMessage= $event"
    :rules="rules"
    :show-error-message="false"
    :placeholder="$t('pages.submissions.components.customerMessage.textarea.placeholder')"
  >
  </FouTextArea>

  <fou-group v-if="Object.hasOwn(errors, 'customerMessage uploads')">
    <p class="mt-error" :class="$style.errorMessage">{{errors['customerMessage uploads']}}</p>
  </fou-group>
</fou-group>
